import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import type { RecurringInvoiceEvent } from '@features/recurringInvoices/types/recurringInvoiceEvent'

import { RecurringInvoiceTimeline } from '../RecurringInvoiceTimeline'
import { useSupportedRecurringInvoiceEvents } from './hooks/useSupportedRecurringInvoiceEvents'
import { getRecurringHistoryStatusEventLabel } from './utils/getRecurringHistoryStatusEventLabel'
import { getTimelineStatusByRecurringInvoiceEventType } from './utils/getTimelineStatusByRecurringInvoiceEventType'

const getTimelineItemStatus = (item: RecurringInvoiceEvent) =>
  getTimelineStatusByRecurringInvoiceEventType(item?.eventType)

const getTimelineItemDate = (item: RecurringInvoiceEvent) => item.createdAt

export const RecurringInvoiceHistory = () => {
  const { t } = useTranslation()
  const { supportedRecurringInvoiceEvents, isLoading } = useSupportedRecurringInvoiceEvents()

  const getTimelineStatusItemTitle = useCallback(
    (item: RecurringInvoiceEvent): string => getRecurringHistoryStatusEventLabel(item.eventType, t),
    [t],
  )

  return (
    <RecurringInvoiceTimeline
      items={supportedRecurringInvoiceEvents}
      getItemDate={getTimelineItemDate}
      getItemTitle={getTimelineStatusItemTitle}
      getItemStatus={getTimelineItemStatus}
      isLoading={isLoading}
      title={t('recurring_invoices.page.timeline.title')}
    />
  )
}
